import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Unsubscribe";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    cms: {
      api: {
        endpoints: {
          unsubscribe: {
            headers: {
              "Content-Type": "application/json",
              moduleCode: null,
            },
            doc: "https://tranxactor-uat.txweb.site",
            url:
              setup.setup.api.tranxactor.url[environment] + "/gdpr/unsubscribe",
            method: "PUT",
          },
        },
      },
    },
  },
  routes: {
    label: "Unsubscribe",
    prefix: "/u",
  },
};

export default config;
